export const config = {
    apiKey: "AIzaSyCvBsOYHlBVxTkE-t3PuEz3wrwt0UllsFU",
    authDomain: "whoamaiwebapp.firebaseapp.com",
    projectId: "whoamaiwebapp",
    storageBucket: "whoamaiwebapp.appspot.com",
    messagingSenderId: "544596315415",
    appId: "1:544596315415:web:76a2b4c438e38597e17b52",
    measurementId: "G-S1ZHSSHMRP"
  }